import React from 'react';
import Modal from '../../Modal/Modal';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import useTranslation from '../../../Hooks/useTranslation';

interface PriceHintModalProps {
	opened: boolean;
	onClose: any;
	healthPlanCode: HealthPlanCode;
}

interface HealthPlanTexts {
	title: string;
	text: string;
	list: string[];
	text2?: string;
}

const TEXTS: Record<HealthPlanCode, HealthPlanTexts> = {
	[HealthPlanCode.DIABETES]: {
		title: 'diabetes.infoModalPrice.title',
		text: 'diabetes.infoModalPrice.text',
		list: [
			'diabetes.infoModalPrice.items.item1',
			'diabetes.infoModalPrice.items.item2',
			'diabetes.infoModalPrice.items.item3',
			'diabetes.infoModalPrice.items.item4',
			'diabetes.infoModalPrice.items.item5',
			'diabetes.infoModalPrice.items.item7',
			'diabetes.infoModalPrice.items.item8',
			'diabetes.infoModalPrice.items.item9',
			'diabetes.infoModalPrice.items.item10',
			'diabetes.infoModalPrice.items.item11',
			'diabetes.infoModalPrice.items.item12',
			'diabetes.infoModalPrice.items.item13',
		],
	},
	[HealthPlanCode.BABY]: {
		title: 'component.healthPlanPricing.baby.priceInfoModal.title',
		text: 'component.healthPlanPricing.baby.priceInfoModal.text',
		list: [
			'component.healthPlanPricing.baby.priceInfoModal.items.item1',
			'component.healthPlanPricing.baby.priceInfoModal.items.item2',
			'component.healthPlanPricing.baby.priceInfoModal.items.item3',
			'component.healthPlanPricing.baby.priceInfoModal.items.item4',
			'component.healthPlanPricing.baby.priceInfoModal.items.item5',
			'component.healthPlanPricing.baby.priceInfoModal.items.item6',
			'component.healthPlanPricing.baby.priceInfoModal.items.item7',
			'component.healthPlanPricing.baby.priceInfoModal.items.item8',
			'component.healthPlanPricing.baby.priceInfoModal.items.item9',
			'component.healthPlanPricing.baby.priceInfoModal.items.item10',
			'component.healthPlanPricing.baby.priceInfoModal.items.item11',
			'component.healthPlanPricing.baby.priceInfoModal.items.item12',
		],
		text2: 'component.healthPlanPricing.baby.priceInfoModal.text2',
	},
};

export default function PriceHintModal(props: PriceHintModalProps) {
	const { opened, onClose, healthPlanCode } = props;
	const { t } = useTranslation();

	if (!TEXTS[healthPlanCode]) {
		return <></>;
	}

	return (
		<Modal opened={opened} onClose={onClose}>
			<Modal.Header title={t(TEXTS[healthPlanCode].title)} />
			<Modal.Content contentScroll={true}>
				<p>{t(TEXTS[healthPlanCode].text)}</p>
				<ul>
					{TEXTS[healthPlanCode].list.map(item => (
						<li>{t(item)}</li>
					))}
				</ul>
				{TEXTS[healthPlanCode].text2 && <p>{t(TEXTS[healthPlanCode].text2)}</p>}
			</Modal.Content>
		</Modal>
	);
}
